/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationGroupType } from './OrganizationGroupType';
import {
    OrganizationGroupTypeFromJSON,
    OrganizationGroupTypeFromJSONTyped,
    OrganizationGroupTypeToJSON,
    OrganizationGroupTypeToJSONTyped,
} from './OrganizationGroupType';

/**
 * 
 * @export
 * @interface OrganizationGroupUpdateRequest
 */
export interface OrganizationGroupUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupUpdateRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupUpdateRequest
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupUpdateRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {OrganizationGroupType}
     * @memberof OrganizationGroupUpdateRequest
     */
    organizationGroupType?: OrganizationGroupType;
}



/**
 * Check if a given object implements the OrganizationGroupUpdateRequest interface.
 */
export function instanceOfOrganizationGroupUpdateRequest(value: object): value is OrganizationGroupUpdateRequest {
    return true;
}

export function OrganizationGroupUpdateRequestFromJSON(json: any): OrganizationGroupUpdateRequest {
    return OrganizationGroupUpdateRequestFromJSONTyped(json, false);
}

export function OrganizationGroupUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationGroupUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'organizationGroupType': json['organizationGroupType'] == null ? undefined : OrganizationGroupTypeFromJSON(json['organizationGroupType']),
    };
}

export function OrganizationGroupUpdateRequestToJSON(json: any): OrganizationGroupUpdateRequest {
    return OrganizationGroupUpdateRequestToJSONTyped(json, false);
}

export function OrganizationGroupUpdateRequestToJSONTyped(value?: OrganizationGroupUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'shortName': value['shortName'],
        'description': value['description'],
        'applicationId': value['applicationId'],
        'organizationGroupType': OrganizationGroupTypeToJSON(value['organizationGroupType']),
    };
}

